import { CONTACT_POINT_SYSTEM, REGEX_EXPS } from "utils/constants";
import { normalizeTextField, stripAllSpaces } from "utils/helpers/validations";
import * as yup from "yup";

const validation = (messages) => {
  const requiredName = yup
    .string()
    .transform(normalizeTextField)
    .typeError(messages.REQUIRED)
    .matches(REGEX_EXPS.name, messages.INVALID_NAME)
    .required(messages.REQUIRED);

  return yup.object().shape({
    contact: yup.object().shape({
      user: yup.object().shape({
        firstname: requiredName,
        lastname: requiredName,
      }),
      fields: yup.object().shape({
        // acceptDigital: yup.boolean().oneOf([true], messages.REQUIRED),
        // acceptContact: yup.boolean().oneOf([true], messages.REQUIRED),
      }),
      telecoms: yup.object().shape({
        [CONTACT_POINT_SYSTEM.EMAIL]: yup.object().shape({
          value: yup
            .string()
            .nullable()
            .email(messages.EMAIL)
            .required(messages.REQUIRED),
        }),
        [CONTACT_POINT_SYSTEM.PHONE]: yup.object().shape({
          value: yup
            .string()
            .transform(stripAllSpaces)
            .typeError(messages.REQUIRED)
            .required(messages.REQUIRED)
            .test("isValid", messages.INVALID_VALUE, async function (value) {
              return new RegExp(REGEX_EXPS.phone).test(value);
            }),
        }),
        [CONTACT_POINT_SYSTEM.ADHERENT_NUMBER]: yup.object().shape({
          value: yup
            .string()
            .transform(stripAllSpaces)
            .required(messages.REQUIRED)
            .matches(/^\d{8}$/, messages.INVALID_VALUE),
        }),
      }),
    }),
  });
};

export default validation;
